import { verifyAccessToken } from './verifyAccessToken'

export const getMcUserIdFromToken = async (
  accessToken: string,
): Promise<string | null> => {
  const grantsKey = process.env.CORE_AUTH_GRANTS_KEY
  if (!grantsKey) return null

  let userIdKey: string
  try {
    userIdKey = `${new URL(grantsKey).origin}/identity/v1/claims/user_id`
  } catch {
    return null
  }

  const payload = await verifyAccessToken(accessToken)
  if (!payload) return null

  const userId = payload[userIdKey]
  return typeof userId === 'string' ? userId : null
}
